<div (click)="_onStepClicked()" [class.activeWrapper]="state === 'inProgress'" data-test="setup-menu-step-button">
  <h4 class="step" [ngClass]="{ active: state === 'inProgress', 'sn-locked': state === 'complete' }">
    <span *ngIf="state === 'complete'" class="stepNumber"> <img src="../../../assets/grey_checkmark.svg" class="checkmark" /></span>
    <span *ngIf="state === 'inProgress'" class="stepNumber"> <img src="../../../assets/blue_checkmark.svg" class="checkmark" /></span>
    <span *ngIf="state !== 'complete' && state !== 'inProgress'" class="stepNumber">{{ stepNumber + 1 | number: '2.0' }}</span>
    <span class="stepName">{{ stepName }}</span>
  </h4>
</div>
